import React from 'react';
import { useQuery } from 'react-query';
import { HiOutlineDocumentText } from "react-icons/hi";

import SideNavBar from '../../../components/nav/side-navbar';
import DocumentManager from '../../../components/fileManagement/components/DocumentManager';
import { API_AUTH_TYPES, API_ROUTES, ApiRequest } from '../../../api';
import useConfig from '../../../hooks/useConfig';

const Documents = () => {
    const { isAdvisor, householdId } = useConfig();
    // Fetch onboarding module data to check if vault step is completed
    const householdsApi = new ApiRequest(API_ROUTES.HOUSEHOLDS, API_AUTH_TYPES.CLIENT);
    const { data: onboardingData, isLoading } = useQuery({
        queryKey: ['onboarding-module'],
        queryFn: householdsApi.getFn({ endpoint: 'onboarding_module', queryParams: {household_id: householdId} }),
    });

    // Check if vault upload step is completed
    const isVaultStepCompleted = !isLoading && (onboardingData?.has_uploaded_documents || onboardingData?.onboarding_module_completed);

    return (
        <SideNavBar bgColor="bg-gray-100">
            <div className=" relative">
                <div className="">


                    {/* Document Request Alert - Only show if vault step not completed */}
                    {!isVaultStepCompleted && !isLoading && (
                        <div className="mb-8">
                            <div className="bg-blue-50 rounded-2xl border border-blue-200 shadow-lg">
                                <div className="px-6 py-8">
                                    <div className="flex items-start gap-4">
                                        <div className="flex-shrink-0 mt-1">
                                            <HiOutlineDocumentText className="h-8 w-8 text-blue-600" />
                                        </div>
                                        <div>
                                            <h2 className="text-xl font-medium text-gray-900 mb-4">Documents Requested for Onboarding</h2>
                                            <p className="text-gray-700 mb-4">
                                                Please upload the following documents to complete your onboarding process.
                                            </p>
                                            <p className="text-gray-700 italic font-bold mb-4">
                                                Only upload documents that are relevant to your financial situation.
                                            </p>
                                            <ul className="list-disc pl-5 space-y-2 text-gray-700">
                                                <li>Last tax return</li>
                                                <li>Social Security statements + "Record of Earnings"</li>
                                                <li>Paystub for each of you</li>
                                                <li>Mortgage statement</li>
                                                <li>Declarations statements for your home, auto, and umbrella (if applicable) insurance policies</li>
                                                <li>Recent statements of life insurance and/or long-term care insurance policies</li>
                                                <li>Any completed estate planning documents</li>
                                                <li>List of available funds in your 401k & HSAs, inc. expense ratios</li>
                                                <li>Stock grant vesting schedule + ESPP details</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Document Manager Section */}
                    <div className="pb-16">
                        <div className="bg-white rounded-2xl border border-gray-200 shadow-lg">
                            <div className="px-6 py-8">
                                <DocumentManager authType={isAdvisor ? API_AUTH_TYPES.ADVISOR : API_AUTH_TYPES.USER} householdIdForAdvisor={householdId} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SideNavBar>
    );
};

export default Documents;